export class DashboardCardsList {
	CardID: number;
	CardTitle: string;
	ConfigJSON: string;
	DisplayOrder: number;
	Hidden: Boolean;
}

export class DashboardOrder {
	CardID: number;
	DisplayOrder: number;
	Hidden: Boolean;
	SystemID: string;
	UserID: number;
}

export class DailyResidualsResponse {
	DailyResiduals: number | null[];
}

export class ResidualsOutlookResponse {

	TotalPayout: number;
	PayChange: number;
	TotalPerM: number;
	PerMChange: number;
	ResOutlook: ResidualsOutlook[];
}

export class ResidualsOutlook {
	CommissionsDate: Date | string;
	TotalRes: number;
}
export interface IChartDataset {
	label: string;
	data: Array<any>;

}

export class ChartDataSet implements IChartDataset {

	label: string = null;
	data: Array<any> = null;

	constructor(src?: IChartDataset) {
		if (src) {
			this.label = src.label;
			this.data = src.data;

		}
	}

}